import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { IAttendance } from '../../../../shared/interfaces/attendance/IAttendance';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';
import i18n from '../../../../utils/localization/i18n';

interface IProps {
  open: boolean;
  attendance: IAttendance | null;
  setLastAttendance: React.Dispatch<React.SetStateAction<IAttendance | null>>;
  handleClose: () => void;
  handleSubmit: () => void;
}
const AttendanceManualFormModal = ({
  attendance,
  setLastAttendance,
  open,
  handleClose,
  handleSubmit,
}: IProps) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={'MuiModalBody'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: { xs: '80%', lg: '30%' },
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            mb: '30px',
            pb: '10px',
            borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography id="modal-modal-title" variant="h6">
            {t('button.changeStopTime')}
          </Typography>
        </Box>
        <Box sx={{ pb: '30px', width: '100%' }}>
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale={i18n.language}
          >
            <DemoContainer components={['DateTimePicker']}>
              <DateTimePicker
                sx={{ width: '100%' }}
                ampm={false}
                format="DD.MM.YYYY - HH:mm"
                value={moment(attendance?.endDate ?? new Date())}
                label={t('general.endDate')}
                onChange={(date) => {
                  setLastAttendance(
                    (prevState) =>
                      ({
                        ...prevState,
                        endDate: new Date(
                          moment(date)?.toISOString(),
                        ).toLocaleString('en', {
                          timeZone: 'Europe/Amsterdam',
                        }),
                      }) as IAttendance,
                  );
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
        <div>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            {t('button.cancel')}
          </Button>
          <Button variant={'contained'} size={'small'} onClick={handleSubmit}>
            {t('button.update')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
export default AttendanceManualFormModal;
